import React, { useState } from "react";
import { Modal, Result, Button } from "antd";
import { FaBan } from "react-icons/fa";

export const SiteBlockedModal = ({ isModalOpen, setModal, modal }) => {
    const contactLines = modal?.Contact
    ? modal.Contact.split("\n")
    : [];
  return (
    <Modal
      title={null}
      open={isModalOpen}
      onCancel={() => setModal(null)}
      footer={null}
      width={520}
      centered
    >
      <Result
        status="error"
        icon={
          <div className="flex justify-center">
            <FaBan className="text-red-500 text-6xl" />
          </div>
        }
        title="Site is blocked"
        subTitle={
          contactLines.length > 0
            ? contactLines.map((line, idx) => <div key={idx}>{line}</div>)
            : "The requested site is currently blocked by your network or administrator. This could be due to security policies, content filtering, or temporary restrictions."
        }
        // extra={[
        //   <Button type="primary" key="retry" onClick={handleRetry}>
        //     Close
        //   </Button>,
        // ]}
      />
    </Modal>
  );
};
